import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { ACCOUNT_MANAGEMENT } from "@consts";
import { HyroLoader } from "@hyro-components";
import AccountSettingsContent from "./AccountSettingsContent";
import useAccountSettings from "./AccountSettings.hook";

const AccountSettings = () => {
  const { accountId } = useParams();
  const {
    accountRow,
    accountData,
    isAccountContext,
    isLoading,
    isSaving,
    isConfirmationOpen,
    error,
    errorText,
    setError,
    searchParams,
    handleSubmit,
    handleDiscard,
    openConfirmation,
    closeConfirmation
  } = useAccountSettings();

  if (isLoading) {
    return <HyroLoader />;
  }

  if (!isLoading && !accountRow) {
    return <Navigate to={isAccountContext ? `/${accountId}` : `/admin/${ACCOUNT_MANAGEMENT}`} replace />;
  }

  return (
    <AccountSettingsContent
      accountData={accountData}
      isAccountContext={isAccountContext}
      isSaving={isSaving}
      isConfirmationOpen={isConfirmationOpen}
      onSave={openConfirmation}
      onSubmit={handleSubmit}
      onConfirmationClose={closeConfirmation}
      onDiscard={handleDiscard}
      error={error}
      errorText={errorText}
      setError={setError}
      searchParams={searchParams}
    />
  );
};

export default AccountSettings;
